
import React from 'react';
import { Route } from 'react-router-dom';
import Treatments from '@/pages/Treatments';
import Botox from '@/pages/treatments/Botox';
import LipFiller from '@/pages/treatments/LipFiller';
import Kybella from '@/pages/treatments/Kybella';
import PRF from '@/pages/treatments/PRF';
import SkinBoosters from '@/pages/treatments/SkinBoosters';
import VIPeel from '@/pages/treatments/VIPeel';
import LaserFacial from '@/pages/treatments/LaserFacial';
import RFMicroneedling from '@/pages/treatments/RFMicroneedling';
import UltrasoundFacial from '@/pages/treatments/UltrasoundFacial';
import AquaFirme from '@/pages/treatments/AquaFirme';
import Dermaplaning from '@/pages/treatments/Dermaplaning';
import IVTherapy from '@/pages/treatments/IVTherapy';
import LipotropicInjections from '@/pages/treatments/LipotropicInjections';

export const TreatmentRoutes = () => (
  <>
    <Route path="/treatments" element={<Treatments />} />
    <Route path="/treatments/botox" element={<Botox />} />
    <Route path="/treatments/lip-filler" element={<LipFiller />} />
    <Route path="/treatments/kybella" element={<Kybella />} />
    <Route path="/treatments/prf" element={<PRF />} />
    <Route path="/treatments/skin-boosters" element={<SkinBoosters />} />
    <Route path="/treatments/vi-peel" element={<VIPeel />} />
    <Route path="/treatments/laser-facial" element={<LaserFacial />} />
    <Route path="/treatments/rf-microneedling" element={<RFMicroneedling />} />
    <Route path="/treatments/ultrasound-facial" element={<UltrasoundFacial />} />
    <Route path="/treatments/aqua-firme" element={<AquaFirme />} />
    <Route path="/treatments/dermaplaning" element={<Dermaplaning />} />
    <Route path="/treatments/iv-therapy" element={<IVTherapy />} />
    <Route path="/treatments/lipotropic-injections" element={<LipotropicInjections />} />
  </>
);
